import React, { Suspense, lazy, useEffect } from 'react'
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
// import {usePropertiesContext} from './context/PropertiesContext';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap'
import '../src/assets/css/style.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'react-tabs/style/react-tabs.css'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

// Pages
import Error404 from './pages/Error404'
import Home from './pages/Home'
// import IndividualListing from './pages/IndividualListing'
// import Blogs from './pages/Blogs'
// import Blog from './pages/Blog'
// import ProfilePriyanka from './pages/ProfilePriyanka'
// import ProfileRiddhiBhagchandani from './pages/ProfileRiddhiBhagchandani'

// NEW IMPORTS

// import ProfileArsalanNadkar from './pages/ProfileArsalanNadkar'
// import AmalBenYoussef from './pages/AmalBenYoussef'
// import ManalMahri from './pages/ManalMahri'

// Route-level code splitting: each page is downloaded only when it is visited
const HomeNew = lazy(() => import('./pages/HomeNew'))
const FAQs = lazy(() => import('./pages/FAQs'))
const ContactUs = lazy(() => import('./pages/ContactUs'))
const Why800Homes = lazy(() => import('./pages/Why800Homes'))
const Leadership = lazy(() => import('./pages/Leadership'))
const WhyDubai = lazy(() => import('./pages/WhyDubai'))
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'))
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions'))
const Careers = lazy(() => import('./pages/Careers'))
const BuyProperty = lazy(() => import('./pages/BuyProperty'))
const SellProperty = lazy(() => import('./pages/SellProperty'))
const Events = lazy(() => import('./pages/Events'))
const EventDetail = lazy(() => import('./pages/EventDetail'))
const ThankYou = lazy(() => import('./pages/ThankYou'))
const PropertyDetails = lazy(() => import('./pages/PropertyDetails'))
const ProfileFaraazSiddiqui = lazy(() => import('./pages/ProfileFaraazSiddiqui'))
const ProfileAanilMannwani = lazy(() => import('./pages/ProfileAanilMannwani'))
const Profile800Homes = lazy(() => import('./pages/Profile800Homes'))
const ProfileBhwnaManvani = lazy(() => import('./pages/ProfileBhwnaManvani'))
const TeamPage = lazy(() => import('./pages/TeamPage'))
const News = lazy(() => import('./pages/News'))
const NewsDetail = lazy(() => import('./pages/NewsDetail'))
const ReellyProperties = lazy(() => import('./pages/ReellyProperties'))
const Brochure = lazy(() => import('./pages/Brochure'))
const Reports = lazy(() => import('./pages/Reports'))
const DubaiInvestment = lazy(() => import('./pages/DubaiInvestment'))
const MohamedElnagr = lazy(() => import('./pages/MohamedElnagr'))
const ZunairaTazkeerHussain = lazy(() => import('./pages/ZunairaTazkeerHussain'))
const LakshayChoudhary = lazy(() => import('./pages/LakshayChoudhary'))
const Uday = lazy(() => import('./pages/Uday'))
const Yash = lazy(() => import('./pages/Yash'))
const Anam = lazy(() => import('./pages/Anam'))
const Anum = lazy(() => import('./pages/Anum'))
const Rashmi = lazy(() => import('./pages/Rashmi'))
const AjmalMusthafa = lazy(() => import('./pages/AjmalMusthafa'))
const MohammadSalmanBadusha = lazy(() => import('./pages/MohammadSalmanBadusha'))
const AwardsAndAchievements = lazy(() => import('./pages/AwardsAndAchievements'))
const FrancisMari = lazy(() => import('./pages/FrancisMari'))
const MortgageCalculator = lazy(() => import('./pages/MortgageCalculator'))
const BrochureDetail = lazy(() => import('./pages/BrochureDetails'))

const CanonicalMetadata = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const canonicalPath =
        location.pathname === '/' ? '/' : `${location.pathname.replace(/\/+$/, '')}/`
    const canonicalUrl = `https://800homes.ae${canonicalPath}`

    useEffect(() => {
        if (location.pathname !== canonicalPath) {
            navigate(
                {
                    pathname: canonicalPath,
                    search: location.search,
                    hash: location.hash,
                },
                { replace: true },
            )
        }
    }, [canonicalPath, location.hash, location.pathname, location.search, navigate])

    return (
        <Helmet>
            <link rel="canonical" href={canonicalUrl} />
            <meta property="og:url" content={canonicalUrl} />
        </Helmet>
    )
}

const App = () => {
    // const {properties} = usePropertiesContext();

    return (
        <>
            <CanonicalMetadata />
            <main>
            <Suspense fallback={null}>
            <Routes>
                <Route path="*" element={<Error404 />} />

                <Route path="/thank-you/" element={<ThankYou />} />

                <Route path="/faraaz-siddiqui/" element={<ProfileFaraazSiddiqui />} />
                <Route path="/aanil-mannwani/" element={<ProfileAanilMannwani />} />

                {/* <Route path="/priyanka-dev/" element={<ProfilePriyanka />} /> */}
                {/* <Route path="/arsalan-nadkar/" element={<ProfileArsalanNadkar />} /> */}
                {/* <Route path="/riddhi-bhagchandani/" element={<ProfileRiddhiBhagchandani />} /> */}
                {/* <Route path="/khushi-rajpoot/" element={<ProfileKhushiRajpoot />} /> */}

                <Route path="/bhwna-manvani/" element={<ProfileBhwnaManvani />} />

                {/* <Route path="/riya-mehta/" element={<ProfileRiya />} /> */}

                <Route path="/800-homes-real-estate-brokerage/" element={<Profile800Homes />} />
                <Route path="/mohamed-elnagr/" element={<MohamedElnagr />} />

                {/* <Route path="/amal-ben-youssef/" element={<AmalBenYoussef />} /> */}
                {/* <Route path="/manal-mahri/" element={<ManalMahri />} /> */}

                <Route path="/zunaira-tazkeer-hussain/" element={<ZunairaTazkeerHussain />} />
                <Route path="/zunaira-hussain/" element={<ZunairaTazkeerHussain />} />
                <Route path="/lakshay-choudhary/" element={<LakshayChoudhary />} />

                <Route path="/uday/" element={<Uday />} />
                <Route path="/yash/" element={<Yash />} />
                <Route path="/anam/" element={<Anam />} />
                <Route path="/anum/" element={<Anum />} />
                <Route path="/rashmi/" element={<Rashmi />} />
                <Route path="/ajmal-musthafa/" element={<AjmalMusthafa />} />
                <Route path="/francis-mari/" element={<FrancisMari />} />
                <Route path="/mohammad-salman-badusha/" element={<MohammadSalmanBadusha />} />

                <Route path="/" element={<Home />} />
                <Route path="/home-new/" element={<HomeNew />} />

                <Route path="/why-800-homes/" element={<Why800Homes />} />
                <Route path="/awards-and-achievements/" element={<AwardsAndAchievements />} />
                <Route path="/why-dubai/" element={<WhyDubai />} />
                <Route path="/leadership/" element={<Leadership />} />
                <Route path="/our-team/" element={<TeamPage />} />

                <Route path="/sell-property/" element={<SellProperty />} />
                <Route path="/properties-for-sale/" element={<BuyProperty />} />

                <Route path="/property/:slug/" element={<PropertyDetails />} />

                <Route path="/careers/" element={<Careers />} />
                <Route path="/faqs/" element={<FAQs />} />

                {/* <Route path="/blogs/" element={<Blogs />} /> */}
                {/* <Route path="/blog/:slug/" element={<Blog />} /> */}

                <Route path="/projects/" element={<ReellyProperties />} />

                <Route path="/news/" element={<News />} />
                <Route path="/news/:slug/" element={<NewsDetail />} />

                {/* NEW ROUTES */}

                <Route path="/brochures/" element={<Brochure />} />
                <Route path="/brochure/:slug/" element={<BrochureDetail />} />
                <Route path="/reports/" element={<Reports />} />

                <Route path="/events/" element={<Events />} />
                <Route path="/events/:slug/" element={<EventDetail />} />

                <Route path="/dubai-property-investment/" element={<DubaiInvestment />} />

                <Route path="/mortgage-calculator/" element={<MortgageCalculator />} />

                <Route path="/contact-us/" element={<ContactUs />} />

                <Route path="/privacy-policy/" element={<PrivacyPolicy />} />

                <Route path="/terms-and-conditions/" element={<TermsAndConditions />} />
            </Routes>
            </Suspense>
            </main>

            <ToastContainer position="bottom-left" autoClose={5000} />
        </>
    )
}

export default App
